angular.module('leave')
    .factory('LeaveDayOff', function ($resource) {
        return $resource('/crm/api/leave-day-off/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            importHolidays: {method: 'POST', url: '/crm/api/leave-day-off/import'},
            queryCount: {method: 'GET', url: '/crm/api/leave-day-off/count', isArray: false}
        })
    })
    .service('LeaveDayOffService', function ($rootScope, toastr, modals, LeaveDayOff) {
        this.edit = id => {
            return LeaveDayOff.get({id: id}, entity => editModal(entity))
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return editModal(entity)
        };
        this.importModal = () => {
            return modals.open('app/leave/day-off/import-modal.html', 'LeaveDayOffImportController', {}, {size: "sm"}, "$ctrl");
        };
        this.remove = item => {
            let itemName = `dzień wolny z dnia ${item.date}`
            return modals.confirmDelete(itemName, () => LeaveDayOff.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('leave-day-off.updated')));
        }

        function editModal(entity) {
            return modals.open('app/leave/day-off/edit-modal.html', 'LeaveDayOffDialogController', entity, {size: "sm"}, "$ctrl");
        }
    })
    .controller('LeaveDayOffDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, LeaveDayOff) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = LeaveDayOff.update(this.item).$promise
            } else {
                promise = LeaveDayOff.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('leave-day-off.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };
    })
    .controller('LeaveDayOffImportController', function ($rootScope, $uibModalInstance, toastr, LeaveDayOff) {
        this.minYear = 2020
        this.maxYear = 2100
        this.form = {
            year: new Date().getFullYear()
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.importYear = () => {
            return LeaveDayOff.importHolidays({year: this.form.year}, {}).$promise.then(result => {
                $uibModalInstance.close(result)
                $rootScope.$broadcast('leave-day-off.updated')

                if (result.importedCount > 0) {
                    toastr.success(`Zaimportowano dni wolne: ${result.importedCount}. Pominięto istniejące: ${result.skippedCount}.`)
                } else if (result.availableCount > 0) {
                    toastr.info(`Wszystkie dni wolne dla roku ${result.year} już istnieją.`)
                } else {
                    toastr.info(`OpenHolidays API nie zwróciło dni wolnych dla roku ${result.year}.`)
                }
                return result
            })
        }
    })
    .component('leaveDayOffList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/leave/day-off/list.html',
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, LeaveDayOffService, InvoiceService, Principal) {
            this.reset = () => this.filters = {}
            this.InvoiceService = InvoiceService
            this.LeaveDayOffService = LeaveDayOffService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_LEAVE_MANAGER'])
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/leave-day-off-batch/export?" + $httpParamSerializer(paramsAll)
            }

            $scope.$on('leave-day-off.updated', () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('leaveDayOffList', {
            parent: 'app',
            url: '/leave-day-off?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_LEAVE_MANAGER']
            },
            views: {
                'content@': 'leaveDayOffList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (LeaveDayOff, $stateParams) => LeaveDayOff.list($stateParams).$promise
            }
        })
    })
